'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntlProviderContainer = exports.intlProviderBuilder = undefined;

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _actions = require('./actions');

var IntlProviderActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var intlProviderBuilder = exports.intlProviderBuilder = function intlProviderBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, IntlProviderActions)(_reactIntl.IntlProvider);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.i18n.locale,
    messages: state.i18n.messages
  };
};

var IntlProviderContainer = exports.IntlProviderContainer = intlProviderBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/IntlProviderContainer/IntlProviderContainer.js
 ** module id = 470
 ** module chunks = 0
 **/